import * as API from '../api'

export const FETCHING_RATING = 'FETCHING_RATING'
export const FETCH_RATING = 'FETCH_RATING'
export const FETCH_RATING_ERROR = 'FETCH_RATING_ERROR'

export const FETCHING_RATINGS = 'FETCHING_RATINGS'
export const FETCH_RATINGS = 'FETCH_RATINGS'
export const FETCH_RATINGS_ERROR = 'FETCH_RATINGS_ERROR'

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

export const EDIT_RATING = 'EDIT_RATING'
export const CHANGE_RATING = 'CHANGE_RATING'

export const FORM_TOUCHED = 'FORM_TOUCHED'

export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'

export const CHANGE_DETAILS_PAGE = 'CHANGE_DETAILS_PAGE'
export const CHANGE_DETAILS_PER_PAGE = 'CHANGE_DETAILS_PER_PAGE'
export const CHANGE_DETAILS_ORDER_COLUMN = 'CHANGE_DETAILS_ORDER_COLUMN'
export const CHANGE_DETAILS_ORDER_DIRECTION = 'CHANGE_DETAILS_ORDER_DIRECTION'

export const RATING_FORM_ERROR = 'RATING_FORM_ERROR'
export const RESET_STATE = 'RESET_STATE'

export const FETCHING_DETAILS_RATINGS = 'FETCHING_DETAILS_RATINGS'
export const FETCH_DETAILS_RATINGS = 'FETCH_DETAILS_RATINGS'
export const FETCH_DETAILS_RATINGS_ERROR = 'FETCH_DETAILS_RATINGS_ERROR'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeRating = rating => {
  return dispatch => {
    dispatch({ type: CHANGE_RATING, rating })
  }
}

const getInvalidField = errorMessage => {
  const [x, field = ''] = /validation failed: (.*):/.exec(errorMessage) || [] // eslint-disable-line
  return field
}

export const handleRatingError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('validation failed'):
      dispatch({
        type: FORM_TOUCHED
      })

      dispatch({
        type: RATING_FORM_ERROR,
        field: getInvalidField(errorMessage),
        message: `${getInvalidField(errorMessage)} é inválido.`
      })

      return Promise.reject(res)
    default:
      break
  }
}

export const setRatingFormTouched = rating => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeDetailsOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_DETAILS_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const changeDetailsOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_DETAILS_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangeDetailsPage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_DETAILS_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const handleChangeDetailsPerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_DETAILS_PER_PAGE, perPage })
  }
}

export const fetchContentRatings = params => {
  return dispatch => {
    dispatch({ type: FETCHING_DETAILS_RATINGS })

    return API.ratings
      .getContentRatings(params)
      .then((res = {}) => {
        const { data } = res

        dispatch({
          type: FETCH_DETAILS_RATINGS,
          ratings: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage,
          contentTitle: data.contentTitle
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_DETAILS_RATINGS_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const fetchRatings = options => {
  return dispatch => {
    dispatch({ type: FETCHING_RATINGS })

    return API.ratings
      .getRatings(options)
      .then((res = {}) => {
        const { data } = res

        dispatch({
          type: FETCH_RATINGS,
          ratings: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_RATINGS_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const fetchRating = id => {
  return dispatch => {
    dispatch({ type: FETCHING_RATING, clear: true })
    dispatch({ type: OPEN_MODAL })

    return API.ratings
      .getRating(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_RATING, rating: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_RATING_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const editRating = rating => {
  const { _id = '', observacao = '', status = '' } = rating
  const data = new FormData()

  data.append('observacao', observacao)
  data.append('status', status)

  return dispatch => {
    dispatch({ type: FETCHING_RATINGS })
    dispatch({ type: FETCHING_RATING })

    return API.ratings
      .editRating(data, _id)
      .then(({ data }) => {
        dispatch({ type: EDIT_RATING, rating: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_RATINGS_ERROR,
          err: message || 'Serviço indisponível'
        })

        handleRatingError(response, dispatch)

        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/ratings.js